import React, { Component } from "react";

class Footer extends Component {
	render() {
		return (
			<div className="footer">
				Copyright &copy; 2019 Michael Semple. All Rights Reserved.
			</div>
		);
	}
}

export default Footer;